module.exports = __webpack_public_path__ + "img/Accelerated_Digital_Settlement_Service.c705a3bf.jpg";